import React from 'react'
import WithusSections from './Components/WithusSections'
import OpenRoleSection from './Components/OpenRoleSection'
import BanerSection from './Components/BanerSection'
const Career = () => {
  return (
    <div>
      <BanerSection />
      <WithusSections />
      <OpenRoleSection />
    </div>
  )
}

export default Career